import React, { Component } from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col
} from "react-bootstrap";
import Dropzone           from "react-dropzone";
import ic_add_image       from "../../../assets/image/ic_add_image.svg";
import Loader             from "../../Loader";

import { IS_VALID }       from "utils";

export default class Create extends Component {
    constructor (props) {
        super(props);

        this.dropzoneRef;
    }

    render () {
        let {
            actions,
            
            isLoadingAction,

            cardType,
            cardName,
            cardImg
        } = this.props;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        let imageSrc = ic_add_image,
            imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '100px',
                height: '100%'
            },
            dropZoneStyle = {
                display: "inline-block",
                verticalAlign: "top"
            },
            isHideX = {
                display: 'none'
            };

        if (IS_VALID(cardImg)) {
            imageSrc = cardImg.preview || cardImg.url;
            imageStyle = {
              ...imageStyle,
              height: '',
              width: '100%',
              maxWidth: '100%',
              maxHeight: '100%'
            };
            dropZoneStyle = {
              verticalAlign: "middle",
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            };
            isHideX = {};
        }

        return (
            <div>
                <Loader loading={isLoadingAction}/>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Card Name {requiredSpan}</ControlLabel>
                            <FormControl
                                value={cardName}
                                onChange={(e) => {
                                    actions.setValue({
                                        cardName: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Card Type {requiredSpan}</ControlLabel>
                            <FormControl
                                value={cardType}
                                onChange={(e) => {
                                    actions.setValue({
                                        cardType: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Card Image</ControlLabel>
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '30px',
                                    height: '30px',
                                    background: 'white',
                                    paddingTop: '4px',
                                    top: '21px',
                                    right: '11px',
                                    textAlign: 'center',
                                    borderRadius: '50px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    ...isHideX
                                }}
                                onClick={() => {
                                    actions.setValue({ cardImg: null });
                                }}
                            >
                                x
                            </div>
                            <Dropzone
                                style={{
                                    position: "",
                                    width: "100%",
                                    height: "300px",
                                    border: "1px solid #e1e1e1",
                                    borderRadius: "0px",
                                    backgroundColor: "#f5f5f5",
                                    ...dropZoneStyle
                                }}
                                accept="image/*"
                                multiple={false}
                                onDropAccepted={(acceptedArray) => {
                                    actions.setValue({ cardImg: acceptedArray[0] });
                                }}
                            >
                                <img
                                style={imageStyle}
                                src={imageSrc}
                                />
                            </Dropzone>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/CardImages/FormContainer/Create.js